'use strict';
var populations = document.querySelectorAll('.population');
var numbers = Array.from(populations).map(function(item) {
    return Number(item.textContent.replace(/,/g, ''));
});
var total = numbers.reduce(function(sum, number) {
    return sum + number;
}, 0);
var average = total / numbers.length;
document.querySelector('.total-population').textContent = total.toLocaleString();
document.querySelector('.average-population').textContent = Math.round(average).toLocaleString();

//# sourceMappingURL=js_get_data_DOM.7d723dd2.js.map
